import { gql } from '@apollo/client';
import { AbsenceTypeSourcesFragment } from './absence-type-sources.fragment';
export const FetchAbsenceSourcesQuery = gql `
    query FetchAbsenceSources($siteSetId: InstitutionSetId!) {
        staffhours {
            settings(siteSetId: $siteSetId) {
                absenceSources {
                    absenceSourceMode
                    availableSources
                    holiday {
                        ...AbsenceTypeSourcesFragment
                    }
                    sick {
                        ...AbsenceTypeSourcesFragment
                    }
                    childSick {
                        ...AbsenceTypeSourcesFragment
                    }
                    absent {
                        ...AbsenceTypeSourcesFragment
                    }
                }
            }
        }
    }
    ${AbsenceTypeSourcesFragment}
`;
